import { render, staticRenderFns } from "./SecurityformsFormHeader.vue?vue&type=template&id=351a8947"
import script from "./SecurityformsFormHeader.vue?vue&type=script&lang=js"
export * from "./SecurityformsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports